import React from 'react';
import SelectTimeButton from '~/components/BookingTimeSelector/components/SelectTimeButton';
import dataTestIds from '~/test/test-ids';

type Props = {
  disabled?: boolean;
  location: any;
  onClick: (...args: any[]) => any;
  selectedSlot?: any;
  visible?: boolean;
  shouldShowApptDateInButton?: boolean;
};

const NextButton = ({
  disabled,
  location,
  onClick,
  selectedSlot,
  visible,
  shouldShowApptDateInButton,
}: Props) => {
  if (!visible) return null;

  return (
    <SelectTimeButton
      borderRadius="8px"
      buttonType="button"
      data-testid={dataTestIds.cdp.bookingFormSubmitBtn}
      defaultButtonCopy="Continue booking"
      disabled={disabled}
      locale="en"
      location={location}
      marginBottom="16px"
      onModalSubmit={onClick}
      selectedSlot={selectedSlot ? [selectedSlot] : []}
      shouldShowApptDateInButton={shouldShowApptDateInButton}
    />
  );
};

export default NextButton;
